export default __webpack_public_path__ + "static/media/3527.0c0b56a7.svg";